import get from 'lodash/get';
import { findComparator, findPredicate } from '../../../filter_conversions';
import { convertDollarsToMills } from '../../../../../utils/helpers/currency';
import { currencyFields } from '../../../../../utils/constants';

const isSelectFilter = resourceName => {
  switch (resourceName) {
    case 'account':
      return true;
    case 'advertiser':
      return true;
    case 'publisher':
      return true;
    default:
      return null;
  }
};

export const generateFilter = (resourceName, dataField, meta) => {
  const { column_info, options, filters } = meta;
  const attributes = get(column_info, 'attributes', {});
  const dropDownOptions = options || {};
  const dropDownColumns = ['status', 'pixel_status', 'advertiser_type', 'roles'];
  const { value, predicate } = get(filters, `${dataField}`, {});
  let filter = {};

  switch (attributes[dataField]) {
    case 'identifier': {
      filter.type = 'TextFilter';
      filter.condition = 'eq';
      filter.defaultValue = '';
      if (value && predicate) filter.defaultValue = value;
      break;
    }
    case 'inet':
    case 'string': {
      filter.type = dropDownColumns.includes(dataField) && isSelectFilter(resourceName) ? 'SelectFilter' : 'TextFilter';
      filter.condition = 'like';
      filter.defaultValue = '';
      filter.options = dropDownOptions[dataField] ? dropDownOptions[dataField] : null;
      break;
    }
    case 'float':
    case 'decimal':
    case 'integer': {
      filter.type = 'NumberFilter';
      filter.numberComparators = ['=', '>', '<'];
      filter.defaultValue = {};
      if (value && predicate) {
        filter.defaultValue = {
          number: parseInt(value, 10),
          comparator: findComparator(predicate),
        };
      }
      break;
    }
    case 'boolean': {
      filter.type = 'SelectFilter';
      filter.options = {
        true: true,
        false: false,
      };
      break;
    }
    case 'datetime': {
      filter.type = 'DateFilter';
      filter.dateComparators = ['=', '>', '<'];
      filter.defaultValue = {};
      if (value && predicate) {
        filter.defaultValue = {
          date: value,
          comparator: findComparator(predicate),
        };
      }
      break;
    }
    default:
      filter = {};
  }

  return filter;
};

export const handleFilterCreation = filterHash => {
  const filters = {};
  Object.entries(filterHash).forEach(([key, { value, predicate }]) => {
    filters[key] = {
      value,
      type: 'SelectFilter',
      props: { cond: predicate || 'like' },
    };
  });

  return filters;
};

export const handleOnFilterChange = (currentParams, fetchDataFunction = null, e) => {
  const filters = { ...currentParams.filters };

  // Remove old table filters so that emptied filters don't remain with their old value
  Object.keys(currentParams?.filters || {}).filter(f => {
    if (currentParams.filters[f].isTableFilter) {
      delete filters[f];
    }
  });

  Object.entries(e).forEach(([field, properties]) => {
    switch (properties.type) {
      case 'TextFilter': {
        const {
          value,
          props: { cond },
        } = properties;
        filters[field] = { value, predicate: cond || 'like', isTableFilter: true };
        break;
      }
      case 'NumberFilter': {
        const {
          value: { comparator, number },
        } = properties;
        const filteredNumber = currencyFields.includes(field) ? convertDollarsToMills(number) : number;
        filters[field] = { value: filteredNumber, predicate: findPredicate(comparator), isTableFilter: true };
        break;
      }
      case 'DateFilter': {
        const {
          value: { comparator, date },
        } = properties;
        filters[field] = { value: date, predicate: findPredicate(comparator), isTableFilter: true };
        break;
      }
      case 'SelectFilter': {
        const {
          value,
          props: { cond },
        } = properties;
        filters[field] = { value, predicate: cond || 'eq', isTableFilter: true };
        break;
      }
      default:
        break;
    }
  });

  if (fetchDataFunction) {
    fetchDataFunction({
      ...currentParams,
      filters,
    });
  } else {
    console.error('Fetch function was not passed to the filter change');
  }
};

export const handleOnDropdownChange = ({ key, predicate = 'eq', defaultValue }, currentParams, fetchDataFunction = null, dropdownSelection) => {
  const value = Array.isArray(dropdownSelection) ? dropdownSelection.map(i => i.value) : dropdownSelection.value;
  const filters = {
    ...currentParams.filters,
  };
  filters[key] = { value: value || defaultValue, predicate };

  if (fetchDataFunction) {
    fetchDataFunction({
      ...currentParams,
      filters,
    });
  } else {
    console.error('Fetch function was not passed to the filter change');
  }
};
